import axios from 'axios';

// Create an Axios Client with defaults
const client = axios.create({
  // baseURL: `https://search-profideo-test-ccwrzmx2rauykviouoly3qmcbe.eu-west-3.es.amazonaws.com`
  // baseURL: `https://03911a6c290e415e86f3de6ab91585d7.eu-central-1.aws.cloud.es.io:9243`
  baseURL: `https://data-indexer-mo9ookah.secure.profideo.com`
});

// Request Wrapper with default success/error actions
const request = function(options: any) {
  const onSuccess = function(response: any) {
    // console.debug('Request Successful!', response)
    return response.data;
  };

  const onError = function(error: any) {
    // console.error('Request Failed:', error.config)

    if (error.response) {
      // Request was made but server responded with something
      console.error("Status:", error.response.status);
      console.error("Data:", error.response.data);
      console.error("Headers:", error.response.headers);
    } else {
      // Something else happened while setting up the request
      console.error("Error Message:", error.message);
    }

    return Promise.reject(error.response || error.message);
  };

  return client(options)
    .then(onSuccess)
    .catch(onError);
};

export default request;
